import {ReloadButton as UIReloadButton} from '@flexinet/ui-components';
import {Box} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';

export const ReloadButton = () => {
    const queryClient = useQueryClient();
    
    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    };
    
    return (
        <Box mx='s'>
            <UIReloadButton onClick={handleReload}/>
        </Box>
    );
};